import Container from "./Container";

export default function Section({
  children,
  className = "",
  tone = "cream",
  padding = "xl",
  id,
  testid,
}) {
  const toneMap = {
    cream: "bg-cream text-charcoal",
    "cream-dark": "bg-[#ECE4D6] text-charcoal",
    charcoal: "bg-charcoal text-cream",
    terracotta: "bg-terracotta text-cream",
    none: "",
  };
  const padMap = {
    sm: "py-16 md:py-20",
    md: "py-20 md:py-28",
    lg: "py-24 md:py-32",
    xl: "py-24 md:py-36 lg:py-40",
    none: "",
  };
  return (
    <section
      id={id}
      data-testid={testid}
      className={`${toneMap[tone]} ${padMap[padding]} ${className}`}
    >
      <Container>{children}</Container>
    </section>
  );
}
